<template>
  <div>
    <translation :key="campaign.id" :value="campaign.name" :loading="loading" :id="campaign.id" @save="save"></translation>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import translation from '@/components/settings/translations/translations'

export default {
  props: ['id'],
  components: { translation },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('campaigns', {
      getById: 'getById'
    }),
    campaign () {
      return this.getById(this.id)
    }
  },
  methods: {
    ...mapActions('campaigns', ['updateCampaign']),

    save (id) {
      this.loading = true

      if (!this.campaign.name.fr) {
        delete this.campaign.name.fr
      }
      if (!this.campaign.name.en) {
        delete this.campaign.name.en
      }

      this.updateCampaign({campaign: {id: this.campaign.id, name: this.campaign.name}})
        .then(() => {
          this.loading = 'success'
          this.$notify({title: 'Success', message: this.$root.$t('notifications.translations.edited'), type: 'success'})
        }).catch(() => {
          this.loading = 'failed'
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/translations/translations_campaign.vue